import { DefaultDirections, SortProviderProps, UrlSortProvider } from '@tableau/data-catalog-shared';
import * as React from 'react';

import { ColumnOrderField, OrderDirection } from '../../../../gen-src/queries/globalTypes';

export type ColumnsValidSortFields = ColumnOrderField.NAME;

export const ColumnsDefaultDirections: DefaultDirections<ColumnsValidSortFields> = {
  [ColumnOrderField.NAME]: OrderDirection.ASC,
};

export const ColumnsDefaultSortField = ColumnOrderField.NAME;

export function ColumnsGridSortProvider(
  props: Pick<SortProviderProps<ColumnsValidSortFields>, 'children'>
): JSX.Element {
  return (
    <UrlSortProvider<ColumnsValidSortFields>
      validOrderFieldsWithDefaultDirections={ColumnsDefaultDirections}
      defaultField={ColumnsDefaultSortField}
    >
      {props.children}
    </UrlSortProvider>
  );
}
